import { css } from '@emotion/react';
import { ROOT_ELEMENT_CLASS_NAME } from '../models';

export const globalStyle = css`
  .${ROOT_ELEMENT_CLASS_NAME} {
    line-height: 1;
    height: 100%;

    *,
    *::before,
    *::after {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    button,
    input,
    select,
    textarea {
      font-family: inherit;
    }

    ol,
    ul {
      list-style: none;
    }

    blockquote,
    q {
      quotes: none;
    }

    blockquote:before,
    blockquote:after,
    q:before,
    q:after {
      content: '';
      content: none;
    }

    table {
      border-collapse: collapse;
      border-spacing: 0;
    }
  }
`;
